module.exports = __webpack_public_path__ + "static/media/cy.947914b1.svg";